export default {
    name: 'الاسم',
    tel: 'الهاتف',
    save: 'حفظ',
    confirm: 'تأكيد',
    cancel: 'إلغاء',
    delete: 'حذف',
    complete: 'إكمال',
    loading: 'جاري التحميل...',
    telEmpty: 'يرجى إدخال رقم الهاتف',
    nameEmpty: 'يرجى ملء الاسم',
    nameInvalid: 'تنسيق الاسم غير صحيح',
    confirmDelete: 'هل أنت متأكد من الحذف؟',
    telInvalid: 'رقم الهاتف غير صحيح',
    vanCalendar: {
        end: 'نهاية',
        start: 'بداية',
        title: 'التقويم',
        startEnd: 'البداية/النهاية',
        weekdays: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: maxRange => `اختر لا يزيد عن ${maxRange} أيام`
    },
    vanCascader: {
        select: 'اختر'
    },
    vanContactCard: {
        addText: 'إضافة معلومات الاتصال'
    },
    vanContactList: {
        addText: 'إضافة جهة اتصال جديدة'
    },
    vanPagination: {
        prev: 'السابق',
        next: 'التالي'
    },
    vanPullRefresh: {
        pulling: 'اسحب للتحديث...',
        loosing: 'أفلت للتحديث...'
    },
    vanSubmitBar: {
        label: 'الإجمالي: '
    },
    vanCoupon: {
        unlimited: 'غير محدود',
        discount: discount => `${discount * 10}% خصم`,
        condition: condition => `على الأقل ${condition}`,
    },
    vanCouponCell: {
        title: 'كوبون',
        tips: 'لا توجد كوبونات',
        count: count => `لديك ${count} كوبونات`,
    },
    vanCouponList: {
        empty: 'لا توجد كوبونات',
        exchange: 'استبدال',
        close: 'إغلاق',
        enable: 'متاح',
        disabled: 'غير متاح',
        placeholder: 'كود الكوبون'
    },
    vanAddressEdit: {
        area: 'المنطقة',
        postal: 'الرمز البريدي',
        areaEmpty: 'الرجاء اختيار منطقة الاستلام',
        addressEmpty: 'لا يمكن أن يكون العنوان فارغًا',
        postalEmpty: 'الرمز البريدي خاطئ',
        defaultAddress: 'تعيين كعنوان افتراضي',
        telPlaceholder: 'الهاتف',
        namePlaceholder: 'الاسم',
        areaPlaceholder: 'المنطقة'
    },
    vanAddressEditDetail: {
        label: 'العنوان',
        placeholder: 'العنوان'
    },
    vanAddressList: {
        add: 'إضافة عنوان جديد'
    }
};